import Vmask from 'vanilla-masker';
import { Nullable } from './aux-types';

export interface IFormatter {
  maskedValue: string;
  rawValue: string;
}

export const formatMoneyStringToFloat = (value: string, options = { decimalSeparator: ',', thousandSeparator: '.' }) => {
  const result = value.replaceAll(options.thousandSeparator, '').replaceAll(options.decimalSeparator, '.');
  return parseFloat(result);
};

export const formatNumberToBRL = (value: Nullable<number | string>, showZero?: boolean) => {
  if (!value && !showZero) {
    return '-';
  }

  const safeParsedValue = typeof value === 'number' ? value : Number(value || 0);
  return safeParsedValue?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
};

export const formatIntToFloat = (value: number, separator = ',') => {
  return `${(value / 100.0).toFixed(2).replace('.', separator)}`;
};

export const formatDecimalToPercentage = (value: number, separator = ',') => {
  return `${(value * 100.0).toFixed(2).replace('.', separator)}%`;
};

export const removeDoubleSpacesAndTrim = (value: string) => {
  return value.trim().replace(/\s+/g, ' ');
};

export const chopKeyAccessNumber = (value: string) => {
  return `${value.trim().substring(0, 5)}...${value.trim().substring(value.length - 5, value.length)}`;
};

const formatter = (mask: string, value?: string): IFormatter => {
  const maskedValue = Vmask.toPattern(value || '', mask);
  return { maskedValue, rawValue: maskedValue.replace(/\D/g, '') };
};

export const phoneFormatter = (value?: string) => formatter('(99) 9 9999-9999', value);
export const cnpjFormatter = (value?: string) => formatter('99.999.999/9999-99', value);
export const cpfFormatter = (value?: string) => formatter('999.999.999-99', value);

export const sliceStringBiggerThan = (text: string | undefined, size: number) => {
  if (!text) {
    return '';
  }

  return text.length > size ? `${text.slice(0, size - 3)}...` : text;
};

export const nullifyObjectEmptyStrings = (obj: object) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: typeof value === 'string' && value === '' ? null : value,
    };
  }, {});
};

export const numberOrEmptyString = (value: Nullable<string | number>) => {
  const isNullable = value === null || value === undefined;

  if (isNullable) return '-';

  const parsedValue = Number(value);

  return Number.isNaN(parsedValue) ? '-' : parsedValue;
};
